import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { setShowTrends } from "src/redux";
import { RootState } from "src/redux/reducers";

import "./TrendsVisibilityToggle.scss";

export const TrendsVisibilityToggle = () => {
  const { showTrends } = useSelector(
    (state: RootState) => state.insightsDashboardReducer,
  );

  const dispatch = useDispatch();

  // Local UI preference only — never persisted to the backend.
  const onChange = () => {
    dispatch(setShowTrends(!showTrends));
  };

  return (
    <div className="trends-visibility-toggle">
      <IDHFormattedMessage id="ws_show_trends" defaultMessage="Show trends" />
      <CustomSwitch checked={showTrends} onChange={onChange} />
    </div>
  );
};
